export default __webpack_public_path__ + "static/media/avatar1.e7e40252.jpg";